import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=b0c0839a&scoped=true&"
import script from "./CancelOrder.vue?vue&type=script&lang=js&"
export * from "./CancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=b0c0839a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0839a",
  null
  
)

export default component.exports